import React from 'react';

import { Outlet } from 'react-router-dom';

import { TabContext, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';

import AcContentWrapper from 'components/AcContentWrapper/AcContentWrapper';
import AcTabs from 'components/AcTabs/AcTabs';
import AcViewWrapper from 'components/AcViewWrapper/AcViewWrapper';

import { TabsPanelProps } from './types';

export const TabsPanel: React.FC<TabsPanelProps> = ({
  className,
  tabs,
  headerComponent,
  handleTabChange,
  activeTabVal,
  padding = true,
  outletContext,
  scrollBodyFillsSpace = false
}) => {
  return (
    <AcViewWrapper
      className={className}
      scrollBodyFillsSpace={scrollBodyFillsSpace}
      header={
        <Box sx={scrollBodyFillsSpace ? { flexShrink: 0 } : undefined}>
          {headerComponent}
          <Box className={`${padding ? 'pl-12 pr-12' : ''}`}>
            <AcTabs
              className="tabPanel-tabs"
              value={activeTabVal}
              onChange={handleTabChange}
            >
              {tabs
                .filter(({ shouldHide }) => !shouldHide)
                .map((tab) => (
                  <Tab key={tab.value} label={tab.label} value={tab.value} />
                ))}
            </AcTabs>
          </Box>
        </Box>
      }
    >
      <AcContentWrapper
        className={
          scrollBodyFillsSpace ? 'flex min-h-0 flex-1 flex-col' : undefined
        }
      >
        <TabContext value={activeTabVal}>
          <TabPanel
            value={activeTabVal}
            sx={{
              padding: 0,
              ...(scrollBodyFillsSpace
                ? {
                    flex: 1,
                    minHeight: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden'
                  }
                : {})
            }}
          >
            <Outlet context={outletContext} />
          </TabPanel>
        </TabContext>
      </AcContentWrapper>
    </AcViewWrapper>
  );
};
